"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const room_session_1 = require("../../../../context/room_session");
const ui_react_1 = require("@streem/ui-react");
const ToolbarButton = (_a) => {
    var { onClick, iconName, activeTool, toolName, label, disableButton, disableTooltip, showErrorMsg, loading, fill, hoverFill, fillLevel, tooltipMessage, tooltipStyles } = _a, props = __rest(_a, ["onClick", "iconName", "activeTool", "toolName", "label", "disableButton", "disableTooltip", "showErrorMsg", "loading", "fill", "hoverFill", "fillLevel", "tooltipMessage", "tooltipStyles"]);
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const [windowBlur, setWindowBlur] = (0, react_1.useState)(false);
    const roomSession = (0, room_session_1.useRoomSession)();
    // If the window loses focus while one of these buttons is in focus, it was showing the tooltip again on window re-focus.
    // So if the button is active when the window loses focus, don't show the tooltip again on refocus and reset that piece of state
    window.onblur = () => {
        var _a;
        if (((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.textContent) === label)
            setWindowBlur(true);
    };
    const show = () => {
        if (windowBlur) {
            setWindowBlur(false);
            return;
        }
        disableTooltip ? setShowTooltip(false) : setShowTooltip(true);
    };
    const hide = () => setShowTooltip(false);
    const disablePointerEvents = disableTooltip && disableButton;
    const isActive = !disablePointerEvents && toolName && activeTool === toolName;
    const handleClick = (e) => {
        toolName && roomSession.tools.setActiveTool(toolName);
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    const defaultMessage = ((0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "dark", size: "small" }, { children: label })));
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Tooltip, Object.assign({ message: tooltipMessage ? tooltipMessage : defaultMessage, showTooltip: showErrorMsg ? showErrorMsg : showTooltip, distance: (tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.distance) || 20, offsetValue: tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.offsetValue, borderRadius: tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.borderRadius, arrowSize: tooltipStyles === null || tooltipStyles === void 0 ? void 0 : tooltipStyles.arrowSize }, { children: !loading ? ((0, jsx_runtime_1.jsx)(ui_react_1.IconButton, { fillLevel: fillLevel, fill: fill ? fill : isActive ? 'white' : ui_react_1.Theme.colors.azure, hoverFill: hoverFill ? hoverFill : isActive ? 'white' : ui_react_1.Theme.colors.azureTransparent, disabledFillOverride: ui_react_1.Theme.colors.azure, background: "transparent", highlight: "transparent", iconName: iconName, label: label, "data-testid": props['data-testid'], disabled: disableButton, onClick: handleClick, onMouseEnter: show, onMouseOver: show, onMouseOut: hide, onFocus: show, onBlur: hide, style: {
                pointerEvents: disablePointerEvents ? 'none' : 'all',
                opacity: disableButton ? 0.2 : 1,
            } })) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ style: { padding: '8px' }, onMouseEnter: show, onMouseOut: hide, onMouseOver: show, onFocus: show, onBlur: hide }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Spinner, { size: "24px" }) }))) })));
};
exports.ToolbarButton = ToolbarButton;
//# sourceMappingURL=toolbar_button.js.map